const getCookie = (name: string): string | undefined => {
    const match = document.cookie.match(new RegExp(`(?:^|\\s)${name}=([^;]*)`));
    return match ? match[1] : undefined;
};

const getSiteSpectIdsFromWindow = (): string | undefined =>
    // @ts-ignore
    typeof window !== 'undefined' && window.sitespect
        ? // @ts-ignore
          window.sitespect
        : undefined;

const parseAppCookie = (appCookie: string): string | undefined => {
    try {
        const decodedCookie = decodeURIComponent(appCookie);
        const data = JSON.parse(decodedCookie);
        return data?.siteSpect || undefined;
    } catch {
        return undefined;
    }
};

const getSiteSpectIdsFromCookie = (): string | undefined => {
    const APPIE_COOKIE = 'appdata';
    const appCookie = getCookie(APPIE_COOKIE);
    return appCookie ? parseAppCookie(appCookie) : undefined;
};

export const getSiteSpectIds = (): string | undefined => {
    return getSiteSpectIdsFromCookie() || getSiteSpectIdsFromWindow();
};
